import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import * as XLSX from 'xlsx';
import Button from '@mui/material/Button';
import { useParams, useHistory } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';


function GstReports() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, token, logout } = useAuth();
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);


    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);

            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }

    };
    useEffect(() => {
        fetchRouteTypes();
    }, []);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const getFirstDayOfMonth = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-01`;
    };

    const getCurrentDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    };



    const handleRouteTypeChange = async (selectedOption) => {
        setSelectedRoute(selectedOption);


        try {
            const response = await fetchData('GstReport', `/${fromDate}/${toDate}/${companyId}/${selectedOption.value}`, token);

            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                setData(dataArray);

            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };
    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    useEffect(() => {
        fetchData();
    }, [fromDate, toDate]);



    useEffect(() => {
        setFromDate(getFirstDayOfMonth());
        setToDate(getCurrentDate());
    }, []);
    const handleRefreshClick = (e) => {
        setFromDate(getFirstDayOfMonth());
        setToDate(getCurrentDate());
        // Reload the window after state updates
        window.location.reload();
    };
    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };

    const handleExportExcel = () => {
        const excelData = [['Sl.No', 'Customer Name', 'GstNo', 'Bill No', 'Bill Amount', 'CGST', 'SGST', 'IGST', 'Total']];
        data.forEach((rowData, index) => {
            excelData.push([
                index + 1,
                rowData.Customername,
                rowData.GstNo,
                rowData.BillNo,
                rowData.BillAmount.toFixed(2),
                rowData.Cgst.toFixed(2),
                rowData.Sgst.toFixed(2),
                rowData.Igst.toFixed(2),
                rowData.Total.toFixed(2)
            ]);
        });
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Gst Report Summary');
        XLSX.writeFile(wb, 'GstReport.xlsx');
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('Failed to open new window. Please allow pop-ups for this website.');
            return;
        }
        const style = `
            <style>
                body, table { font-family: Times New Roman; font-size: 16px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #ddd; padding: 8px; }
                th { background-color: #f3f3f3; font-size: 19px; font-weight: bold; }
                h3 { font-size: 32px; }
            </style>
        `;
        const header = '<html><head><title>GST Report</title>' + style + '</head><body>';
        const footer = '</body></html>';
        let htmlContent = header;
        htmlContent += '<h3>GST REPORT</h3><table><thead><tr>';
        const headers = ['Sl.No', ' Customer Name', 'GstNo', 'Bill No', 'Bill Amount', 'CGST', 'SGST', 'IGST', 'Total'];
        headers.forEach(header => htmlContent += `<th>${header}</th>`);
        htmlContent += '</tr></thead><tbody>';
        data.forEach((rowData, index) => {
            htmlContent += '<tr>';
            htmlContent += `<td>${index + 1}</td>`;
            htmlContent += `<td>${rowData.Customername || ''}</td>`;
            htmlContent += `<td>${rowData.GstNo || ''}</td>`;
            htmlContent += `<td>${rowData.BillNo || ''}</td>`;
            htmlContent += `<td>${rowData.BillAmount.toFixed(2) || ''}</td>`;
            htmlContent += `<td>${rowData.Cgst.toFixed(2) || ''}</td>`;
            htmlContent += `<td>${rowData.Sgst.toFixed(2) || ''}</td>`;
            htmlContent += `<td>${rowData.Igst.toFixed(2) || '0'}</td>`;
            htmlContent += `<td>${rowData.Total || ''}</td>`;
            htmlContent += '</tr>';
        });
        htmlContent += '</tbody></table>' + footer;
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.print();
    };


    // Define filteredDataItem within the component
    const filteredDataItem = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([

        'SL No',
        'Customer Name',
        'GST No ',
        'Bill No.',
        'Bill Amount',
        'CGST',
        'SGST',
        'IGST',
        'Total'

    ]);
    // Process and paginate the data
    const processedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '90%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex items-center' style={{ flexWrap: 'wrap' }}>
                <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>GST REPORT</h6>

                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', marginTop: '10px' }}>
                    {/* Search Input */}
                    <div style={{ marginRight: '8px' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '300px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                marginTop: '20px'
                            }}
                        />
                    </div>

                    {/* From Date */}
                    <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromdate">
                            FromDate
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date" value={fromDate} onChange={handleFromDateChange}
                            style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                        />
                    </div>
                    <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="todate">
                            ToDate
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date" value={toDate} onChange={handleToDateChange}
                            style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                        />
                    </div>

                    <div style={{ marginTop: '-10px', marginLeft: '12px', width: '250px' }}>
                        <Select
                            value={selectedRoute}
                            onChange={handleRouteTypeChange}
                            options={routeOptions}
                            placeholder="Select Route"
                            isSearchable
                            className="mt-1"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '40px',
                                    borderRadius: '12px',
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // keep above sticky header
                                }),
                            }}
                        />
                    </div>
                    <Button
                        style={{
                            backgroundColor: '#C9E9D2',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handleRefreshClick}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                    {/* Export to Excel Button */}
                    <Button
                        style={{
                            backgroundColor: '#F8E8EE',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>Excel</span>
                    </Button>
                    <Button
                        style={{
                            backgroundColor: '#E8F3D6',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handlePrint}
                        className="linkcolor"
                    >
                        <span>Print</span>
                    </Button>


                </div>
            </div>


            {/* Table display */}
            < div className="mt-6" >
                {
                    loading ? (
                        <CircularProgress />
                    ) : (
                        <React.Fragment>

                            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>

                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{
                                            backgroundColor: '#F8F6F4',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1, width: '2500px'
                                        }}>
                                            <TableRow>
                                                {columnOrder.map((col, index) => (
                                                    <TableCell
                                                        key={index}
                                                        style={{
                                                            padding: '6px',
                                                            cursor: 'move',
                                                            color: '#3A4D39',
                                                            fontWeight: 'bold',

                                                        }}
                                                        draggable
                                                        onDragStart={(e) => handleDragStart(e, index)}
                                                        onDragOver={handleDragOver}
                                                        onDrop={(e) => handleDrop(e, index)}
                                                    >
                                                        {col}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>


                                        <TableBody>
                                            {Array.isArray(processedData) && processedData.length > 0 ? (
                                                processedData.map((rowData, index) => {


                                                    const rowValues = {
                                                        'SL No': index + 1,
                                                        'Customer Name': rowData.Customername || '',
                                                        'GST No': rowData.GstNo || '',
                                                        'Bill No': rowData.BillNo || '',
                                                        'Bill Amount': rowData.BillAmount ? rowData.BillAmount.toFixed(2) : '0.00',
                                                        'CGST': rowData.Cgst ? rowData.Cgst.toFixed(2) : '0.00',
                                                        'SGST': rowData.Sgst ? rowData.Sgst.toFixed(2) : '0.00',
                                                        'IGST': rowData.Igst ? rowData.Igst.toFixed(2) : '0.00',
                                                        'Total': rowData.Total ? rowData.Total.toFixed(2) : '0.00',

                                                    };

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <TableRow
                                                                style={{
                                                                    backgroundColor: rowData.OrderTypeHeading === 'TOTAL' ? '#F5EFE3' : 'inherit',

                                                                }}
                                                            >
                                                                {Object.keys(rowValues).map((key) => (
                                                                    <TableCell
                                                                        key={key}
                                                                        sx={{
                                                                            fontSize: '14px',
                                                                            padding: '5px',
                                                                            textAlign: 'left',
                                                                            width: '20px'

                                                                        }}
                                                                    >
                                                                        {rowValues[key]}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </React.Fragment>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={8} sx={{ textAlign: 'center' }}>
                                                        No data available.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        {/* Render Grand Total in Footer */}
                                        <TableFooter style={{ padding: '5px' }}>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                                    count={filteredData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handlePageChange}
                                                    onRowsPerPageChange={handleRowsPerPageChange}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>

                        </React.Fragment>
                    )
                }
            </div >


        </div>
    );
};

export default GstReports;